<template>
    <div>
        <create-variable-card card-type="no3"/>
        <create-formula-card
            :show_sensor_depth_selection="false"
            :show_soil_type_selection="false"
            formula-target="no3"/>
        <formula-list-table :show_sensor_depth_selection="false" formula-target="no3" />
    </div>
</template>

<script>

import FormulaListTable from "@/components/formula-table/FormulaListTable";
import CreateVariablesCard from "../../../components/calculation-table/CreateVariablesCard";
import CreateFormulaCard from "@/components/formula-table/CreateFormulaCard";
import {mapActions, mapState} from "vuex";

export default {
    name: "No3FormulaView",
    components: {
        'create-variable-card': CreateVariablesCard,
        'create-formula-card': CreateFormulaCard,
        'formula-list-table': FormulaListTable,
    },
    computed: {
        ...mapState('formula', ['colors', 'formulaTargets']),
    },
    methods: {
        ...mapActions('formula', ['fetchFormulaColors', 'fetchFormulaTargets', 'fetchAllFormulas']),
        ...mapActions("country", ["fetchCountries"])
    },
    async beforeMount() {
        await this.fetchFormulaTargets('no3')
        !this.colors.length && await this.fetchFormulaColors()
        await this.fetchCountries();
    },
    async mounted() {
        await this.fetchAllFormulas('no3')
    }
}


</script>

<style scoped>

</style>